module.exports = __webpack_public_path__ + "img/tick-circle.66e59f5b.svg";